"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const ToolItem_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Tools/ToolItem.vue"));
const floating_vue_1 = require("floating-vue");
const ColorLibController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ColorLibController"));
let CompositorWidget = class CompositorWidget extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.compositorName = '';
        this.colorManager = new ColorLibController_1.default();
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    updateCompositorName(name) {
        this.compositorName = name;
    }
    get builtSubtitle() {
        return (this.mainProject.project_type[0] +
            ' - ' +
            this.mainProject.area_name +
            ' + ' +
            this.compositableProjects.length);
    }
    categoryTransform(category) {
        if (category)
            return this.colorManager.getAlphaCategory(category);
        return '';
    }
    calculateCSSClasses(category) {
        if (category)
            return this.colorManager.getCSSClassesForCategory(category);
        return '';
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], CompositorWidget.prototype, "mainProject", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], CompositorWidget.prototype, "compositableProjects", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], CompositorWidget.prototype, "theme", void 0);
CompositorWidget = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            ToolItem: ToolItem_vue_1.default,
            CompositionIcon: bmk_ui_framework_1.CompositionIcon,
            Button: bmk_ui_framework_1.Button,
            Dropdown: floating_vue_1.Dropdown,
            InputField: bmk_ui_framework_1.InputField,
            Tag: bmk_ui_framework_1.Tag,
        },
    })
], CompositorWidget);
exports.default = CompositorWidget;
